import angular from 'angular';
import uiRouter from 'angular-ui-router';
import VoucherComponent from './voucher.component';

let VoucherModule = angular.module('Voucher', [
    uiRouter
])

.config(($stateProvider) => {
    'ngInject';
    $stateProvider
        .state('newVoucher', {
            url: '/vouchers/new',
            component: 'voucher',
            parent: 'main',
            data: {
                permissions: {
                    only: ['VOUCHERS'],
                    redirectTo: 'home'
                }
            },
            resolve: {
                registries: (RegistriesService) => RegistriesService.find(),
                user: (LoginService, EmployeesService) => {
                    return LoginService.getCurrent().then(user => {
                        if (user.employeeId) {
                            return EmployeesService.findById(user.employeeId)
                                .then(employee => {
                                    user.employee = employee;
                                    return user;
                                });
                        } else {
                            return user;
                        }
                    });
                }
            }
        })
        .state('editVoucher', {
            url: '/vouchers/:id',
            component: 'voucher',
            parent: 'main',
            data: {
                permissions: {
                    only: ['VOUCHERS', 'VOUCHERCOLLECTOR'],
                    redirectTo: 'home'
                }
            },
            resolve: {
                voucher: (
                    VouchersService,
                    $stateParams
                ) => {
                    return VouchersService.findOne({
                        filter: {
                            where: {
                                id: $stateParams.id
                            },
                            include: [
                                'worker', 'employee', 'assignedEmployee',
                                {
                                    relation: 'pendingSpendings',
                                    scope: {
                                        include: ['registry']
                                    }
                                },
                                {
                                    relation: 'generatedPendingSpendings',
                                    scope: {
                                        include: ['registry']
                                    }
                                },
                                {
                                    relation: 'operativeSpendings',
                                    scope: {
                                        include: ['holder', 'vehicle']
                                    }
                                },
                                {
                                    relation: 'spendings',
                                    scope: {
                                        include: ['spendingType']
                                    }
                                },
                                'createdByUser', 'updatedByUser'
                            ],
                            deleted: true
                        }
                    });
                },
                cashReturns: (VouchersService, $stateParams) => {
                    return VouchersService.findCashReturns(
                        parseInt($stateParams.id, 10)
                    ).then(res => res.transactions);
                },
                registries: (RegistriesService) => RegistriesService.find()
            }
        });
})
.component('voucher', VoucherComponent)
.name;

export default VoucherModule;
